class SearchForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this._searchFormInitialized) return;
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (!this.input) return;

    this._searchFormInitialized = true;
    this.input.form.addEventListener('reset', this.onFormReset.bind(this));
    this._debouncedChange = debounce(() => {
      this.onChange();
    }, 300).bind(this);
    this.input.addEventListener('input', this._debouncedChange);
    /* Hebrew / mobile keyboards: value may not finalize until IME composition ends */
    this.input.addEventListener('compositionend', this._debouncedChange);
  }

  toggleResetButton() {
    if (!this.resetButton || !this.input) return;

    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !this.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');
  }

  onFormReset(event) {
    if (!this.input) return;
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
